import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-lookup",
  "use": "rt-base-lookup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-lookup\"><path d=\"M950.6 899.8L726.2 675.4c-1.6-1.6-1.8-4.2-0.4-6 21.7-26.9 39.4-56.5 53-88.5 19.4-46 29.2-94.7 29.2-144.9s-9.8-98.9-29.2-144.8C760 246.9 733.2 207.1 699 173c-34.2-34.2-73.9-61-118.2-79.7C534.9 73.8 486.2 64 436 64s-98.9 9.8-144.8 29.2C246.9 112 207.1 138.8 173 173c-34.2 34.2-61 73.9-79.7 118.2C73.8 337.1 64 385.8 64 436s9.8 98.9 29.2 144.8C112 625.1 138.8 664.9 173 699c34.2 34.2 73.9 61 118.2 79.7C337.1 798.2 385.8 808 436 808s98.9-9.8 144.8-29.2c32-13.5 61.6-31.3 88.5-53 1.8-1.5 4.4-1.3 6 0.4l224.4 224.4c12.5 12.5 32.7 12.5 45.2 0l5.6-5.6c12.6-12.5 12.6-32.7 0.1-45.2zM436 736c-165.4 0-300-134.6-300-300s134.6-300 300-300 300 134.6 300 300-134.6 300-300 300z\" p-id=\"2291\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/lookup.svg
// module id = 1721
// module chunks = 228